import moment from "moment";
import { isoWeeksPerPeriod, lastPeriodOfYear } from "utils/getIsoPeriodStart";

// Returns the ISO year and period number for a date (same period maths as getIsoPeriodStart). The
// period is clamped to lastPeriodOfYear so week 53 of a 53-week ISO year folds into period 13 rather
// than resolving to a non-existent period 14 — otherwise the reporting-period highlight fails to
// land near the year boundary in a 53-week year.
export default function getIsoPeriodNumber(date) {
    const isoWeek = moment(date).isoWeek();
    const isoYear = moment(date).isoWeekYear();
    return { isoYear: isoYear, isoPeriod: Math.min(Math.ceil(isoWeek / isoWeeksPerPeriod), lastPeriodOfYear) };
}
